<template>
  <span v-if="visitDate">
    {{ visitDate }} - {{ attendeeCount }} {{ attendeeLabel }}
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";

import i18n from "@/lang";

// Narrow cast through `unknown` to bypass TS2589 from vue-i18n v11 generics.
const t: (key: string) => string = (
  i18n.global as unknown as {
    t: (key: string) => string;
  }
).t;

const props = defineProps<{ row: Record<string, unknown> }>();

/**
 * Visit date of the main tickets, formatted by modelkit exactly as the plain
 * date column rendered it before the headcount was appended.
 *
 * @returns {string} Formatted date, empty when the booking carries none.
 */
const visitDate = computed<string>(
  () => (props.row.bookingFirstStartDateString as string) || ""
);

/**
 * Headcount of the first visit date, read from the same
 * `booking_first_quantity_main` field the Back Office column reads.
 *
 * @returns {number} Attendees on the first visit date.
 */
const attendeeCount = computed<number>(
  () => Number(props.row.bookingFirstQuantityMain) || 0
);

/**
 * Attendee noun, singular or plural. Mirrors the keys and the lower-casing
 * modelkit applies when it builds the same suffix for the Back Office, so both
 * lists read identically.
 *
 * @returns {string} Translated attendee noun.
 */
const attendeeLabel = computed<string>(() =>
  t(
    attendeeCount.value > 1 ? "routes.attendees" : "headers.attendee"
  ).toLowerCase()
);
</script>
